module.exports = __webpack_public_path__ + "static/media/redhen_logo.4e561816.png";